/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div[_ngcontent-%COMP%]{font-size:75%;z-index:0;line-height:10px;text-align:left;color:#ff4365;margin-top:1px}"];
export { styles as styles };
